export const HeroWall = () => (
  <section data-testid="hero-section" className="bg-[#231F20]">
    <div className="mx-auto w-full max-w-[1440px]">
      <img
        src="/assets/hero-graphic.webp"
        alt="Gallery wall of original handmade Zan-o-Box sculptures — Zan-o-Box Original, Series #1, 36 handmade Zan-o-Boxes"
        data-testid="hero-wall-image"
        className="block h-auto w-full"
      />
    </div>
  </section>
);
